function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Pulse"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 32,
  "data-height": 24,
  transform: "translate(0 4)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#808080",
  strokeWidth: 1,
  strokeLinecap: "square",
  className: "iconic-property-stroke",
  fill: "none",
  d: "M30.5 15.5h-4.5l-3-5-5 9-5-14.5-6 14.5-2-4h-3.5"
}));

function SvgPulseThinMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "pulse",
    className: "iconic iconic-pulse iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseThinMd);
export default __webpack_public_path__ + "static/media/pulse-thin-md.e3504917.svg";
export { ForwardRef as ReactComponent };